export default {
  'manualPush.pushName': 'Message Name',
  'manualPush.status': 'Status',
  'manualPush.pushTime': 'Push Time',
  'manualPush.createUserName': 'Operator',
  'manualPush.createTime': 'Operation Time',
  'manualPush.opt': 'Operation',
  'manualPush.status.standby': 'Pending',
  'manualPush.status.sending': 'Sending',
  'manualPush.status.send': 'Sent',
  'manualPush.detail': 'Detail',
  'manualPush.add': 'Manual Push',
  'manualPush.modalTitle.create': 'Add Manual Push',
  'manualPush.selectMember': 'Select Member',
  'manualPush.allMembers': 'All Members',
  'manualPush.partialMembers': 'Member',
  'manualPush.agent': 'Agent',
  'manualPush.memberImport': 'Document Import',
  'manualPush.member': 'Member',
  'manualPush.selectLanguage': 'Select Language',
  'manualPush.languagePlaceholder': 'Please select',
  'manualPush.pleaseSelectLanguage': 'Please select language',
  'manualPush.sendTitle': 'Send Title',
  'manualPush.pushContent': 'Push Content',
  'manualPush.jumpPath': 'Jump Path',
  'manualPush.siteStatus': 'Inbox Push Toggle',
  'manualPush.siteStatus.open': 'Enabled',
  'manualPush.siteStatus.close': 'Disabled',
  'manualPush.pleaseSelectSiteStatus': 'Please select inbox push toggle',
  'manualPush.siteType': 'Inbox Message Type',
  'manualPush.pleaseSelectSiteType': 'Please select inbox message type',
  'manualPush.siteType.system': 'System Message',
  'manualPush.siteType.promos': 'Promotion Message',
  'manualPush.siteType.platform': 'Platform Message',
  'manualPush.pleaseInputPushName': 'Please enter message name',
  'manualPush.pleaseInputSendTitle': 'Please enter send title',
  'manualPush.pleaseInputPushContent': 'Please enter push content',
  'manualPush.pleaseInputMembers': 'Please enter member accounts',
  'manualPush.pleaseEnter': 'Please enter',
  'manualPush.max50Characters': 'Within 50 characters',
  'manualPush.max500Characters': 'Within 500 characters',
  'manualPush.enterMemberAccounts': 'Please enter member accounts, separate multiple accounts with commas',
  'manualPush.enterAgentAccounts': 'Please enter agent accounts, separate multiple accounts with commas',
  'manualPush.pleaseInputAgents': 'Please enter agent accounts',
  'manualPush.excelFile': 'Excel File',
  'manualPush.pleaseUploadExcelFile': 'Please upload Excel file',
  'manualPush.fileSizeLimit': 'File size cannot exceed 10MB',
  'manualPush.clickToUpload': 'Click to upload',
  'manualPush.excelFileFormat': 'Supports .xlsx and .xls formats',
  'manualPush.createSuccess': 'Created successfully',
  'manualPush.createFailed': 'Creation failed',
  'manualPush.formValidationFailed': 'Form validation failed',
  'manualPush.downloadSample': 'Download Sample',
  'manualPush.sampleFileDownloaded': 'Sample file downloaded',
  'manualPush.uploadInstructions': 'Upload Instructions',
  'manualPush.instruction1': 'Second column should contain member accounts',
  'manualPush.instruction2': 'File size cannot exceed 10MB',
  'manualPush.instruction3': 'Supports .xlsx and .xls formats',
  'manualPush.membersList': 'Push Members',
  'manualPush.membersCount': 'members',
  'manualPush.reportDetail': 'Push Report Detail',
  'manualPush.pushStatus': 'Push Status',
  'manualPush.pushStatus.success': 'Push Success',
  'manualPush.pushStatus.failed': 'Push Failed',
  'manualPush.pushStatus.pending': 'Pending Push',
  'manualPush.failureReason': 'Failure Reason',
  'manualPush.date': 'Date',
  'manualPush.operator': 'Operator',
  'manualPush.sendUserCount': 'Send User Count',
  'manualPush.pushSuccessToFailed': 'Push Success/Failed',
  'manualPush.pushOpenCount': 'Push Open Count',
  'manualPush.siteMessageSwitch': 'Inbox Message Switch',
  'manualPush.memberType': 'Member Type',
  'manualPush.memberType.specify': 'Specified Members',
  'manualPush.memberType.agent': 'Agent',
  'manualPush.memberType.import': 'Document Import',
  'manualPush.memberType.all': 'All Members',
  'manualPush.pushOpenRate': 'Push Open Rate',
};
